export default __webpack_public_path__ + "static/media/logo.9c0e6c9b.svg";